// extracted by mini-css-extract-plugin
export default {"container":"bepalingen_container__fhhGT"};